// extracted by mini-css-extract-plugin
export default {"sortingSetupPlaceholder":"SortingSetupPlaceholder_sortingSetupPlaceholder__mL6I4","addColumnContainer":"SortingSetupPlaceholder_addColumnContainer__+-vXI"};